// Export all types
export * from "./types/common";
export * from "./types/user";
export * from "./types/text";
export * from "./types/dictation";
export * from "./types/subscription";
export * from "./types/speech";
export * from "./types/features";
export * from "./types/dictionary";
export * from "./types/admin";
export * from "./types/payments";
export * from "./types/notifications";
export * from "./types/audio";
export * from "./types/stripe";
export * from "./types/limits";

// Export client utilities
export * from "./client";

export type {
  ReceivedMaterial,
  ReceivedMaterialsResponse,
} from "./endpoints/materials";

// Import endpoint creators
import { createAdminAnalyticsEndpoints } from "./endpoints/adminAnalytics";
import { createAdminTextQualityEndpoints } from "./endpoints/adminTextQuality";
import { createAuthEndpoints } from "./endpoints/auth";
import { createDictationEndpoints } from "./endpoints/dictation";
import { createDictionaryEndpoints } from "./endpoints/dictionary";
import { createFeaturesEndpoints } from "./endpoints/features";
import { createLearningEndpoints } from "./endpoints/learning";
import { createLimitsEndpoints } from "./endpoints/limits";
import { createMaterialsEndpoints } from "./endpoints/materials";
import { createPaymentsEndpoints } from "./endpoints/payments";
import { createPrivacyEndpoints } from "./endpoints/privacy";
import { createSpeechEndpoints } from "./endpoints/speech";
import { createStripeEndpoints } from "./endpoints/stripe";
import { createStudentsEndpoints } from "./endpoints/students";
import { createSubscriptionsEndpoints } from "./endpoints/subscriptions";
import { createTextsEndpoints } from "./endpoints/texts";
import { createUserEndpoints } from "./endpoints/user";
import { createVoicesEndpoints } from "./endpoints/voices";

// Main API client factory
import type { ClientOptions } from "./client";

export function createApiClient(options: ClientOptions): {
  adminAnalytics: ReturnType<typeof createAdminAnalyticsEndpoints>;
  adminTextQuality: ReturnType<typeof createAdminTextQualityEndpoints>;
  learning: ReturnType<typeof createLearningEndpoints>;
  auth: ReturnType<typeof createAuthEndpoints>;
  user: ReturnType<typeof createUserEndpoints>;
  materials: ReturnType<typeof createMaterialsEndpoints>;
  students: ReturnType<typeof createStudentsEndpoints>;
  texts: ReturnType<typeof createTextsEndpoints>;
  dictation: ReturnType<typeof createDictationEndpoints>;
  dictionary: ReturnType<typeof createDictionaryEndpoints>;
  privacy: ReturnType<typeof createPrivacyEndpoints>;
  voices: ReturnType<typeof createVoicesEndpoints>;
  speech: ReturnType<typeof createSpeechEndpoints>;
  features: ReturnType<typeof createFeaturesEndpoints>;
  subscriptions: ReturnType<typeof createSubscriptionsEndpoints>;
  payments: ReturnType<typeof createPaymentsEndpoints>;
  stripe: ReturnType<typeof createStripeEndpoints>;
  limits: ReturnType<typeof createLimitsEndpoints>;
} {
  const baseUrl = options.baseUrl.replace(/\/$/, "");

  return {
    adminAnalytics: createAdminAnalyticsEndpoints(baseUrl),
    adminTextQuality: createAdminTextQualityEndpoints(baseUrl),
    learning: createLearningEndpoints(baseUrl),
    auth: createAuthEndpoints(baseUrl),
    user: createUserEndpoints(baseUrl),
    materials: createMaterialsEndpoints(baseUrl),
    students: createStudentsEndpoints(baseUrl),
    texts: createTextsEndpoints(baseUrl),
    dictation: createDictationEndpoints(baseUrl),
    dictionary: createDictionaryEndpoints(baseUrl),
    privacy: createPrivacyEndpoints(baseUrl),
    voices: createVoicesEndpoints(baseUrl),
    speech: createSpeechEndpoints(baseUrl),
    features: createFeaturesEndpoints(baseUrl),
    subscriptions: createSubscriptionsEndpoints(baseUrl),
    payments: createPaymentsEndpoints(baseUrl),
    stripe: createStripeEndpoints(baseUrl),
    limits: createLimitsEndpoints(baseUrl),
  };
}
